import moment from 'moment';

export default function isCurrentDateGreater(date) {
	return moment(moment(new Date()).format('MM/DD/YYYY')) > moment(date);
}
